import { render, staticRenderFns } from "./BatchSampleList.vue?vue&type=template&id=3ded3392&scoped=true"
import script from "./BatchSampleList.vue?vue&type=script&lang=js"
export * from "./BatchSampleList.vue?vue&type=script&lang=js"
import style0 from "./BatchSampleList.vue?vue&type=style&index=0&id=3ded3392&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ded3392",
  null
  
)

export default component.exports